import { BsSearch } from "react-icons/bs";
import EachStockComponent, { MobileProductCard, ProductRow } from "./EachStockComponent";
import { FiPlus } from "react-icons/fi";
import { useState, useEffect } from "react";
import { createProductUrl } from "../../../api/endpoints";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Spinner from "../../../components/uxCollections/Loaders";
import { refreshUserToken } from "../../../tools/refreshToken";
import emptyStockImage from "../../../assetsStatic/emptyStock.png";
import { getAllData } from "../../../tools/indexdb";
import { MdFilterList } from "react-icons/md";
import { Search, Filter, Plus, RefreshCw, BarChart3, Eye, AlertTriangle, Package, ChevronDown, X } from "lucide-react";
import { formatToKMB } from "../makeTansaction/checkSales/CheckSalesDisplay";
import { FaPercentage } from "react-icons/fa";
import AddStockModal from "./addProductwithAuto/AddStockModal";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";
const StockPage = ({ updateSelectedProduct, changePage, openModal }) => {
  const [products, setProducts] = useState([]);
  const [productsCopy, setProductsCopy] = useState(null); // this would be used to filter the received order list
  const [productWorth, setProductWorth] = useState("");
  const [storeProductCollection, setStoreProductCollection] = useState({});
  const [filterKeyWord, setFilterKeyWord] = useState("");
  const [lowStockFilter, setLowStockFilter] = useState("All");
  const [reFetchProducts, setReFetchProducts] = useState(false);
  const [isLoading, setIsLoading] = useState(false); //
  const [showInsights, setShowInsights] = useState(false);
  const [showFilterDropdown, setShowFilterDropdown] = useState(false);
  const [openAddProductModal, setOpenAddProductModal] = useState(false);
  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.webStoreUser.user);
  const userCurrency = user?.userCountryCurrencySymbol;
  const { employee } = useSelector((state) => state.employee);

  const navigate = useNavigate();
  useEffect(() => {
    //fetchProducts();
    getStoreProductsFromIndexedDB();
  }, []);
  useEffect(() => {
    if (lowStockFilter === "Low stock") {
      let lowStock = productsCopy.filter((product) => {
        return Number(product.quantity) - Number(product.damagedAmount || 0) <= product.stockLimit;
      });

      if (lowStock.length > 0) {
        setProducts(lowStock);
      } else {
        uiAlert("No product is low on stock");
        setLowStockFilter("All");
      }
    } else {
      setProducts(productsCopy);
    }
  }, [lowStockFilter]);

  useEffect(() => {
    console.log("reFetchProducts changed to ", reFetchProducts);

    getStoreProductsFromIndexedDB();
  }, [reFetchProducts]);

  const getStoreProductsFromIndexedDB = async () => {
    console.log("getting store products from indexedDB");
    setIsLoading(true);
    let storeData = await getAllData(store.storeName);

    try {
      if (storeData) {
        let storeProductCollections = storeData.storeProductCollection;

        if (storeProductCollections.length > 0) {
          setProducts(storeProductCollections);
          setProductsCopy(storeProductCollections);
          let pWorth = storeProductCollections.reduce((acc, cuv) => {
            acc = acc + cuv.quantity * cuv.costPrice;
            return acc;
          }, 0);
          console.log(pWorth);
          setProductWorth(pWorth);
          setStoreProductCollection(storeProductCollections);
          setIsLoading(false);
        } else {
          setProducts([]);
          setProductsCopy([]);
          setStoreProductCollection({
            totalProducts: 0,
          });
          setIsLoading(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProducts = async () => {
    setIsLoading(true);
    let accessToken = localStorage.getItem("accessToken");
    try {
      let response = await fetch(createProductUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.ok) {
        let storeProductCollection = await response.json();

        setProducts(storeProductCollection.products);
        setProductsCopy(storeProductCollection.products);
        let pWorth = storeProductCollection.products.reduce((acc, cuv) => {
          acc = acc + cuv.quantity * cuv.costPrice;
          return acc;
        }, 0);
        console.log(pWorth);
        setProductWorth(pWorth);
        setStoreProductCollection(storeProductCollection);
        setIsLoading(false);
      } else if (response.status === 404) {
        setProducts([]);
        setProductsCopy([]);
        setStoreProductCollection({
          totalProducts: 0,
        });
        setIsLoading(false);
      } else if (response.status === 400) {
        /* alert */
        // setIsLoading(false);
        refreshUserToken(createProductUrl + store._id, fetchProducts, navigate);
      } else {
        uiAlert("An error occured while fetching products, try again later");
        setProducts([]);
        setProductsCopy([]);
        setStoreProductCollection({
          totalProducts: 0,
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const showIntervalTab = () => {
    let tab = document.querySelector(".chooseInterval");

    tab.classList.toggle("showInterval");
  };
  const updateLowStockFilter = (filter) => {
    setLowStockFilter(filter);
    /* showIntervalTab(); */
  };
  return (
    <>
      <div style={{ minHeight: "500px" }}>
        {isLoading ? (
          <Spinner position={"absolute"} transparent={false} backgroundColor={"inherit"} />
        ) : products?.length > 0 ? (
          <>
            <div style={{ overflow: "hidden", height: "100%" }}>
              {/* Header */}
              <div className='stock-header'>
                <div className='stock-header-content'>
                  <div className='stock-title-section'>
                    <h1 className='stock-title'>Products</h1>
                  </div>

                  <div className='stock-controls'>
                    <div className='stock-search-container searchDesktopView'>
                      <Search className='stock-search-icon' size={16} />
                      <input
                        type='text'
                        className='stock-search-input'
                        placeholder='search by name'
                        value={filterKeyWord}
                        onChange={(e) => setFilterKeyWord(e.target.value)}
                      />
                    </div>

                    {/* Filter new */}
                    <div
                      className='stock-filter-btn'
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowFilterDropdown(!showFilterDropdown);
                      }}
                    >
                      <Filter size={16} />
                      {lowStockFilter}
                      <ChevronDown size={14} />
                      {showFilterDropdown && (
                        <div className='stock-filter-dropdown'>
                          <div
                            className={`stock-filter-option ${lowStockFilter === "All" ? "selected" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              updateLowStockFilter("All");
                              setShowFilterDropdown(false);
                            }}
                          >
                            All
                          </div>
                          <div
                            className={`stock-filter-option ${lowStockFilter === "Low stock" ? "selected" : ""}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              updateLowStockFilter("Low stock");
                              setShowFilterDropdown(false);
                            }}
                          >
                            Low stock
                          </div>
                        </div>
                      )}
                    </div>
                    <button className='stock-insights-btn' onClick={() => setShowInsights(true)}>
                      <BarChart3 size={16} />
                      <span className='textNoDisplay'>Insights</span>
                    </button>

                    {user?.createdProdcutsCount === user.maxProduct ? (
                      <button
                        onClick={() => {
                          if (
                            window.confirm(
                              "Maximum allowed products have been created.\n\nUpgrade your subscription to create more products.\n\nDo you want to upgrade now?"
                            )
                          ) {
                            // User clicked OK
                            window.location.href = "/settings"; // or use navigate("/settings") if using react-router
                          }
                        }}
                        className='stock-add-btn'
                      >
                        <Plus size={16} />
                        <span className='textNoDisplay'>Add stock</span>
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          if (employee && employee.employeeAccessLevel !== "admin") {
                            uiAlert("You do not have permission to add a product", "error");
                            return;
                          }

                          setOpenAddProductModal(true);
                          // changePage("addStock");
                        }}
                        className='stock-add-btn'
                      >
                        <Plus size={16} />
                        <span className='textNoDisplay'>Add stock</span>
                      </button>
                    )}
                  </div>
                </div>
                <div className='stock-search-container searchMobileView'>
                  <Search className='stock-search-icon ' size={16} />
                  <input
                    type='text'
                    className='stock-search-input'
                    placeholder='search by name'
                    value={filterKeyWord}
                    onChange={(e) => setFilterKeyWord(e.target.value)}
                  />
                </div>
              </div>

              {/* header ended */}
              {/*  <div className='stockPageTitle'>
                <p>Picture</p>
                <p>Name</p>
                <p>Brand</p>
                <p>Unit price {userCurrency}</p>
                <p>Dis. price {userCurrency}</p>
                <p>Sold amount</p>
                <p>Available</p>
                <p>restock</p>
                <p>view</p>
              </div> */}
              <div className='stock-desktop-view'>
                <div className='stock-table-container'>
                  <table className='stock-table'>
                    <thead className='stock-table-header'>
                      <tr>
                        <th className='stock-table-header-cell'>Picture</th>
                        <th className='stock-table-header-cell'>Name</th>
                        <th className='stock-table-header-cell'>Brand</th>
                        <th className='stock-table-header-cell'>Unit price {user.userCountryCurrencySymbol}</th>
                        <th className='stock-table-header-cell'>Dis. price {user.userCountryCurrencySymbol}</th>
                        <th className='stock-table-header-cell'>Sold amount</th>
                        <th className='stock-table-header-cell'>Available</th>
                        <th className='stock-table-header-cell'>restock</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...products]
                        .filter((filteredProducts) => filteredProducts.name?.toLowerCase().includes(filterKeyWord.toLowerCase()))
                        .sort((a, b) =>
                          a.name.localeCompare(b.name, undefined, {
                            numeric: true,
                            sensitivity: "base",
                          })
                        )
                        .map((product, i) => (
                          <ProductRow
                            key={i}
                            refreshData={setReFetchProducts}
                            product={product}
                            updateSelectedProduct={updateSelectedProduct}
                            user={user}
                            viewStockDtails={changePage}
                          />
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className='stock-mobile-view'>
                {products
                  .filter((filteredProducts) => filteredProducts.name?.toLowerCase().includes(filterKeyWord.toLowerCase()))
                  .splice(0)
                  .reverse()
                  .map((product, i) => (
                    <MobileProductCard
                      viewStockDtails={changePage}
                      key={i}
                      refreshData={setReFetchProducts}
                      product={product}
                      updateSelectedProduct={updateSelectedProduct}
                      user={user}
                    />
                  ))}
              </div>
              {/*   <div className='stockPageWrapper'>
                network detch with ID for stock detail 
                     {products
                  .filter((filteredProducts) => filteredProducts.name?.toLowerCase().includes(filterKeyWord.toLowerCase()))
                  .splice(0)
                  .reverse()
                  .map((product, i) => (
                    <EachStockComponent
                      updateSelectedProduct={updateSelectedProduct}
                      key={i}
                      viewStockDtails={changePage}
                      product={product}
                      refreshData={setReFetchProducts}
                    />
                  ))} 
              </div> */}
            </div>
            {/*  <div className='bottomDivSTockPage'>
              <div>
                <div>
                  <span className='itemsStockpT'>Items:</span>
                  <span>{storeProductCollection.length} </span>
                </div>
                <div>
                  <span className='itemsStockpT'>Worth:</span>
                  <span>
                    {" "}
                    {user.userCountryCurrencySymbol} {productWorth}
                  </span>
                </div>
              </div>
              <div className='addStockDIv'>
                {products?.length > 0 && (
                  <button onClick={() => openModal(true)} className='CheckStockBtn'>
                    Check Stock
                  </button>
                )}
                {user?.createdProdcutsCount === user.maxProduct ? (
                  <button
                    onClick={() => {
                      if (
                        window.confirm(
                          "Maximum allowed products have been created.\n\nUpgrade your subscription to create more products.\n\nDo you want to upgrade now?"
                        )
                      ) {
                        // User clicked OK
                        window.location.href = "/settings"; // or use navigate("/settings") if using react-router
                      }
                    }}
                    className='addStockBtn'
                  >
                    <FiPlus size={26} /> Add stock
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      changePage("addStock");
                      console.log(15 === user.maxProduct);
                    }}
                    className='addStockBtn'
                  >
                    <FiPlus size={26} /> Add stock
                  </button>
                )}
              </div>
            </div> */}
          </>
        ) : (
          <>
            <div className='noInventoryCreatedDiv'>
              <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710424134/static%20images%20storelens/emptyStock_g9pfks.png"} />
            </div>
            <div className='bottomDivSTockPage'>
              <div>
                <div>
                  <span className='itemsStockpT'>Items:</span>
                  <span>{storeProductCollection.totalProducts} </span>
                </div>
                <div>
                  <span className='itemsStockpT'>Worth:</span>
                  <span> {formatToKMB(Number(productWorth), user.userCountryCurrencySymbol)}</span>
                </div>
              </div>
              <div className='addStockDIv'>
                <button style={{ opacity: "0.7", cursor: "not-allowed" }} className='CheckStockBtn'>
                  Check Stock
                </button>
                {/*   <button onClick={() => changePage("addStock")} className='addStockBtn'>
                  <FiPlus size={26} /> Add stock
                </button> */}
                {15 === user.maxProduct ? (
                  <button
                    onClick={() => {
                      if (
                        window.confirm(
                          "Maximum allowed products have been created.\n\nUpgrade your subscription to create more products.\n\nDo you want to upgrade now?"
                        )
                      ) {
                        // User clicked OK
                        window.location.href = "/settings"; // or use navigate("/settings") if using react-router
                      }
                    }}
                    className='addStockBtn'
                  >
                    <FiPlus size={26} /> Add stock
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      //changePage("addStock");
                      setOpenAddProductModal(true);
                    }}
                    className='addStockBtn'
                  >
                    <FiPlus size={26} /> Add stock
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {showInsights && (
        <div className={`stock-insights-overlay ${showInsights ? "show" : ""}`} onClick={() => setShowInsights(false)}>
          <div className={`stock-insights-panel ${showInsights ? "show" : ""}`} onClick={(e) => e.stopPropagation()}>
            <div className='stock-insights-header'>
              <h2 className='stock-insights-title'>Stock Insights</h2>
              <button className='stock-insights-close' onClick={() => setShowInsights(false)}>
                <X size={16} />
              </button>
            </div>

            <div className='stock-insights-content'>
              <div className='stock-insight-card'>
                <div className='stock-insight-value'>{storeProductCollection.length}</div>
                <div className='stock-insight-label'>Items Count</div>
              </div>
              <div className='stock-insight-card'>
                <div className='stock-insight-value'>{formatToKMB(Number(productWorth), user.userCountryCurrencySymbol)}</div>
                <div className='stock-insight-label'>Product Worth</div>
              </div>
            </div>

            <div className='btnDiv-con64'>
              {" "}
              <button
                onClick={() => {
                  if (products.length < 1) {
                    uiAlert("No product in stock to check");
                    return;
                  }

                  setShowInsights(false);
                  openModal(true);
                }}
                className='stock-insight-filter-note'
              >
                Check stock
              </button>
            </div>
          </div>
        </div>
      )}
      {openAddProductModal && (
        <AddStockModal
          isOpen={openAddProductModal}
          onClose={() => {
            setOpenAddProductModal(false);
          }}
          onManualEntry={() => {
            changePage("addStock");
          }}
          onFileUpload={() => {
            changePage("addProductWithExcel");
          }}
          onAIPhotoScan={() => {
            console.log("AI photo scan clicked");
            changePage("addProductWithAI");
          }}
        />
      )}
    </>
  );
};

export default StockPage;
